export function TrustpilotSvg() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 10.2389L10.5417 9.4681L11.8125 13.3848L7.5 10.2389ZM14.5 5.17643H9.14583L7.5 0.134766L5.85417 5.17643H0.5L4.83334 8.30143L3.1875 13.3431L7.52083 10.2181L10.1875 8.30143L14.5 5.17643Z"
        fill="#219653"
      />
    </svg>
  );
}
